import { useCallback } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { useImpersonation } from "@/contexts/ImpersonationContext";
import { logEvent } from "@/hooks/use-event-log";

/**
 * Felles audit for CRM-mutasjoner. Aktør er ALLTID den faktisk innloggede
 * brukeren (useAuth); ved impersonering ligger den impersonerte i
 * payload.on_behalf_of. Payloaden må aldri inneholde kundeinnhold.
 */
export function useCrmAudit() {
  const { user: authUser } = useAuth();
  const { activeUser, isImpersonating } = useImpersonation();
  const authUserId = authUser?.id ?? null;
  const onBehalfOf = isImpersonating && activeUser ? activeUser.id : null;

  const log = useCallback(
    (input: {
      eventType: string;
      entityType: string;
      entityId: string;
      payload?: Record<string, unknown>;
    }) => {
      if (!authUserId) return;
      void logEvent({
        event_type: input.eventType,
        entity_type: input.entityType,
        entity_id: input.entityId,
        user_id: authUserId,
        payload: { ...input.payload, ...(onBehalfOf ? { on_behalf_of: onBehalfOf } : {}) },
      });
    },
    [authUserId, onBehalfOf],
  );

  return { authUserId, log };
}
